import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n'], ['\n  position: relative;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: none;\n  width: 100%;\n  line-height: ', ';\n  padding: ', ' ', ';\n  outline: none;\n  font-weight: 400;\n  color: ', ';\n  border-radius: ', ';\n  background: none;\n  &.focus,\n  &:hover {\n    background-color: ', ';\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &.duration {\n    display: inline-block;\n    font-size: ', ';\n    width: 80px;\n    text-align: center;\n    padding-bottom: 6px;\n  }\n'], ['\n  border: none;\n  width: 100%;\n  line-height: ', ';\n  padding: ', ' ', ';\n  outline: none;\n  font-weight: 400;\n  color: ', ';\n  border-radius: ', ';\n  background: none;\n  &.focus,\n  &:hover {\n    background-color: ', ';\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &.duration {\n    display: inline-block;\n    font-size: ', ';\n    width: 80px;\n    text-align: center;\n    padding-bottom: 6px;\n  }\n']);

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import styled from 'styled-components';
import { styles } from 'gipsy-misc';

var propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  paramName: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool
};

var defaultProps = {
  value: ''
};

var TextAreaAutosize = function (_Component) {
  _inherits(TextAreaAutosize, _Component);

  function TextAreaAutosize(props) {
    _classCallCheck(this, TextAreaAutosize);

    var _this = _possibleConstructorReturn(this, (TextAreaAutosize.__proto__ || Object.getPrototypeOf(TextAreaAutosize)).call(this, props));

    _this.focus = function () {
      _this.textarea.focus();
    };

    _this.blur = function () {
      if (!_this.state.focus) {
        return;
      }
      _this.setState({ focus: false }, function () {
        return _this.textarea.blur();
      });
    };

    _this.onFocus = function (e) {
      _this.setState({
        focus: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.onBlur = function (e) {
      _this.setState({
        focus: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur({
          paramName: _this.props.paramName,
          value: _this.props.value
        });
      }
    };

    _this.onSubmit = function (e) {
      e.preventDefault();
      _this.setState({
        lastValue: _this.props.value
      });

      if (_this.props.onSubmit) {
        _this.props.onSubmit({
          paramName: _this.props.paramName,
          value: _this.props.value
        });
      }
    };

    _this.onCancel = function (e) {
      if (_this.props.value !== _this.state.lastValue) {
        _this.onChange(null, _this.state.lastValue);
      }
      if (_this.props.onCancel) {
        _this.props.onCancel(e);
      }
    };

    _this.onChange = function (e, value) {
      if (_this.props.onChange) {
        _this.props.onChange({
          paramName: _this.props.paramName,
          value: e ? e.target.value : value
        });
      }
    };

    _this.onKeyDown = function (e) {
      if (e.keyCode === 13) {
        /* enter keypress */
        _this.blur();
        _this.onSubmit(e);
      } else if (e.keyCode === 27) {
        /* esc keypress */
        _this.blur();
      }
    };

    _this.state = {
      lastValue: props.value,
      focus: false
    };
    return _this;
  }

  /*
   ** We use handmade shouldComponentUpdate instead of PureComponent in order to ignore the onChange function
   ** it allows us to create a new function on every render in the parent : onChange={() => { doSomething() }}
   ** without rerendering the component everytime the parent is rendered (PureComponent have this side effect )
   */


  _createClass(TextAreaAutosize, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onChange', 'onSubmit', 'onFocus', 'onBlur', 'onKeyDown'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }

        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      if (this.state.focus !== nextState.focus) {
        return true;
      }
      return false;
    }

    /* called from outside in TimeInput */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          paramName = _props.paramName,
          onChange = _props.onChange,
          value = _props.value,
          props = _objectWithoutProperties(_props, ['className', 'paramName', 'onChange', 'value']);

      var focus = this.state.focus;


      return React.createElement(
        Container,
        { className: this.props.className },
        React.createElement(StyledTextArea, _extends({}, props, {
          inputRef: function inputRef(ref) {
            _this2.textarea = ref;
          },
          autoFocus: true,
          onKeyDown: this.onKeyDown,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          className: focus ? 'focus ' : '',
          value: this.props.value
        }))
      );
    }
  }]);

  return TextAreaAutosize;
}(Component);

TextAreaAutosize.propTypes = propTypes;
TextAreaAutosize.defaultProps = defaultProps;

export default TextAreaAutosize;

var Container = styled.div(_templateObject);

var StyledTextArea = styled(Textarea)(_templateObject2, styles.fonts.fontSize, styles.spacings.xsmall, styles.spacings.normal, styles.colors.textDarkColor, styles.spacings.tiny, styles.colors.backgroundGreyColor, styles.colors.textPlaceholderColor, styles.fonts.fontSize);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TextAreaAutosize/index.js
// module id = 829
// module chunks = 0